import Vue from 'vue'
import Vuex from 'vuex'
import data from './data'
import dashboard from './dashboard'
import exports from './exports'
import notifications from './notifications'
import ui from './ui'
import account from './account'
import builder from './builder'
import dashboardAccount from './dashboardAccount'

Vue.config.devtools = true

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

const state = {}

const vuexStore = new Vuex.Store({
    state,
    modules: {
        account,
        builder,
        data,
        dashboard,
        exports,
        notifications,
        ui,
        dashboardAccount
    },
    strict: debug
})

export default vuexStore
